import { DateRangeInput } from 'browser/components/atomic-elements/atoms/input/date-range-input/date-range-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const DateRangeField = LabelFieldFactory({ InputComponent: DateRangeInput })
export {DateRangeField}
